import { InputText } from "./InputText/InputText";
import { InputButtonText } from "./InputButtonText/InputButtonText";
import { InputImage } from "./InputImage/InputImage";
import { InputToggle } from "./InputToggle/InputToggle";
import { InputSelect } from "./InputSelect/InputSelect";
import { InputQuantity } from "./InputQuantity/InputQuantity";
import { InputDate } from "./InputDate/InputDate";
import { InputRangedDate } from "./InputDate/InputRangedDate";
import { InputCheckbox } from "./InputCheckbox/InputCheckbox";
import { InputSignature } from "./InputSignature/InputSignature";
import { InputList } from "./InputList/InputList";
export const Input = {
    Text: InputText,
    ButtonText: InputButtonText,
    Image: InputImage,
    Toggle: InputToggle,
    Select: InputSelect,
    Quantity: InputQuantity,
    Date: InputDate,
    RangedDate: InputRangedDate,
    Checkbox: InputCheckbox,
    Signature: InputSignature,
    List: InputList,
};
export * from "./InputText/InputText";
export * from "./InputButtonText/InputButtonText";
export * from "./InputImage/InputImage";
export * from "./InputToggle/InputToggle";
export * from "./InputSelect/InputSelect";
export * from "./InputCheckbox/InputCheckbox";
export * from "./InputDate/InputDate";
export * from "./InputDate/InputRangedDate";
export * from "./InputSignature/InputSignature";
export * from "./InputList/InputList";
//# sourceMappingURL=index.js.map